import { useParams } from 'react-router-dom';
import { all } from '../data/all';
import NotFound from './NotFound';
import CountryRender from './CountryRender';

function CountryView() {
    const { country } = useParams();

    let countryData = [];

    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = thisCountry;
        }
    })

    if (countryData.length === 0) {
        return (
            <NotFound />
        )
    } else {
        return (
            <CountryRender data={countryData} />
        )
    }
}

export default CountryView;